import React from "react";

import { useTranslation } from "react-i18next";

import type { Locales, ProjectTranslation } from "@/src/api/ProjectAPI.types";

import type { SignupCustomField, SignupCustomIndex } from "./SignupCustomInput";

interface SignupTranslateFormInputProps {
  field: `custom_${SignupCustomIndex}`;
  locales: Locales;
  title: string;
  translations: ProjectTranslation[];
  name: keyof SignupCustomField;
  onChange: (
    language: keyof Locales,
    param: `custom_${SignupCustomIndex}`,
    name: keyof SignupCustomField,
    value: string,
  ) => void;
}

function SignupTranslateFormInput({
  field,
  locales,
  title,
  translations,
  name,
  onChange,
}: SignupTranslateFormInputProps) {
  const { t } = useTranslation("languages");

  const handleChange = (
    translation: ProjectTranslation,
    value: string,
  ): void => {
    onChange(translation.language as keyof Locales, field, name, value);
  };

  return (
    <div className="editor-form-translates">
      <div className="editor-form-section-title">{title}</div>
      {translations?.map((translation) => {
        const { language } = translation;

        const customInputValue =
          locales?.[language as keyof Locales]?.login?.[field];

        const value = customInputValue
          ? (JSON.parse(customInputValue)[name] as string)
          : "";

        return (
          <div
            key={`${field}-${name}-${language}`}
            className="editor-form-translate"
          >
            <label htmlFor={`${field}-${name}-${language}`}>
              {t(`languages:langs.${language}`)}
            </label>
            <input
              key={`${field}-${name}-value-${language}`}
              className="editor-form-input-title"
              id={`${field}-${name}-${language}`}
              maxLength={64}
              type="text"
              value={value}
              onChange={(e) => {
                handleChange(translation, e.target.value);
              }}
            />
          </div>
        );
      })}
    </div>
  );
}

export default SignupTranslateFormInput;
